export default __webpack_public_path__ + "static/media/lounge.711e98c8.jpg";